import { inject, Injectable } from '@angular/core';
import { ValueCardRepository } from '../repositories/value-card.repository';
import { ValueCardBalance } from '../types/value-card-balance';

@Injectable()
export class ValueCardService {
  readonly #repository = inject(ValueCardRepository);

  valueCardBalance(valueCardNumber: string): Promise<ValueCardBalance> {
    return this.#repository.valueCardBalance(valueCardNumber);
  }
}
